export const config = {
    maxFreeTims:"1",
    version: '1.0.1',
    imgSrcHost:'https://statics.imgkits.com',
    CLIENT_ID:"15766724294-5ui2p4vro2cvh16vt3d3eqmhj3m100kg.apps.googleusercontent.com",
    API_KEY: "AIzaSyAzGPwP4vJ835vgfocNqULshWSztuzBl9M",
    DISCOVERY_DOC: "https://www.googleapis.com/discovery/v1/apis/drive/v3/rest",
    SCOPES:"https://www.googleapis.com/auth/drive.file",
  }
  